import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircle, faCircleCheck } from '@fortawesome/free-regular-svg-icons';
export const QuestionForm = ({ question: questionData, action, onAdd, onCancel, }) => {
    const [validationMessage, setValidationMessage] = useState('');
    const [question, setQuestion] = useState(questionData);
    const handleTextChange = (e) => {
        if (e.target.value.length <= 350) {
            setQuestion({ ...question, text: e.target.value });
        }
        else {
            e.target.value = e.target.value.slice(0, 350);
        }
    };
    const handleOptionAChange = (e) => {
        if (e.target.value.length <= 100) {
            setQuestion({ ...question, optionA: e.target.value });
        }
        else {
            e.target.value = e.target.value.slice(0, 100);
        }
    };
    const handleOptionBChange = (e) => {
        if (e.target.value.length <= 100) {
            setQuestion({ ...question, optionB: e.target.value });
        }
        else {
            e.target.value = e.target.value.slice(0, 100);
        }
    };
    const handleOptionCChange = (e) => {
        if (e.target.value.length <= 100) {
            setQuestion({ ...question, optionC: e.target.value });
        }
        else {
            e.target.value = e.target.value.slice(0, 100);
        }
    };
    const handleOptionDChange = (e) => {
        if (e.target.value.length <= 100) {
            setQuestion({ ...question, optionD: e.target.value });
        }
        else {
            e.target.value = e.target.value.slice(0, 100);
        }
    };
    const handleAnswerChange = (e) => {
        const answerId = e.target.id;
        setQuestion({ ...question, answer: answerId });
    };
    return (React.createElement("div", { id: action },
        React.createElement("div", { className: "question-form__container" },
            React.createElement("div", { className: "question-form__content" },
                React.createElement("div", { className: "question-form__text" },
                    React.createElement("textarea", { className: "question-form__text-area", placeholder: "Question", value: question.text, onChange: handleTextChange, onFocus: () => {
                            setValidationMessage('');
                        } }),
                    React.createElement("label", { className: "character-limit" },
                        question.text.length,
                        " / 350")),
                React.createElement("div", { className: "question-form__options" },
                    React.createElement("div", { className: "question-form__option" },
                        React.createElement("input", { type: "text", placeholder: "Option A", value: question.optionA, onChange: handleOptionAChange, onFocus: () => {
                                setValidationMessage('');
                            } }),
                        React.createElement(FontAwesomeIcon, { id: "A", icon: question.answer === 'A' ? faCircleCheck : faCircle, className: "faQuestionOption", onClick: handleAnswerChange })),
                    React.createElement("div", { className: "question-form__option" },
                        React.createElement("input", { type: "text", placeholder: "Option B", value: question.optionB, onChange: handleOptionBChange, onFocus: () => {
                                setValidationMessage('');
                            } }),
                        React.createElement(FontAwesomeIcon, { id: "B", icon: question.answer === 'B' ? faCircleCheck : faCircle, className: "faQuestionOption", onClick: handleAnswerChange })),
                    React.createElement("div", { className: "question-form__option" },
                        React.createElement("input", { type: "text", placeholder: "Option C", value: question.optionC, onChange: handleOptionCChange, onFocus: () => {
                                setValidationMessage('');
                            } }),
                        React.createElement(FontAwesomeIcon, { id: "C", icon: question.answer === 'C' ? faCircleCheck : faCircle, className: "faQuestionOption", onClick: handleAnswerChange })),
                    React.createElement("div", { className: "question-form__option" },
                        React.createElement("input", { type: "text", placeholder: "Option D", value: question.optionD, onChange: handleOptionDChange, onFocus: () => {
                                setValidationMessage('');
                            } }),
                        React.createElement(FontAwesomeIcon, { id: "D", icon: question.answer === 'D' ? faCircleCheck : faCircle, className: "faQuestionOption", onClick: handleAnswerChange }))),
                React.createElement("div", { className: "question-form__controls" },
                    React.createElement("button", { className: "btn--primary", onClick: () => {
                            if (question.text === '' ||
                                question.optionA === '' ||
                                question.optionB === '' ||
                                question.optionC === '' ||
                                question.optionD === '') {
                                setValidationMessage('Cannot leave empty');
                            }
                            else if (!question.answer) {
                                setValidationMessage('Please select a correct option');
                            }
                            else {
                                onAdd(question);
                                setQuestion({
                                    ...questionData,
                                });
                                setValidationMessage('');
                            }
                        } }, questionData.questionId ? 'Update' : 'Add'),
                    action !== 'create' && (React.createElement("button", { className: "btn--secondary", onClick: () => {
                            onCancel();
                            setQuestion({ ...questionData });
                        } }, "Cancel")))),
            React.createElement("p", { className: "validation-message" }, validationMessage))));
};
